import React from "react";
import IotModelViewerBtnProps from "./iot-model-viewer-btn-props.interface";
import "./_iot-model-viewer-btn.scss";

const IotModelViewerBtn = ({ type, icon, content, onClick, className }: IotModelViewerBtnProps) => {
    return (
        <button
        className={`iot-model-viewer-btn${className ? ` ${className}` : ''}`}
        type={type}
        // @ts-ignore
      onClick={onClick}
    >
      {icon}
      <div className={`iot-model-viewer-btn__content${icon && content? ' mt-2':''}`}>{content}</div>
    </button>
  );
};

export default IotModelViewerBtn;
